<template>
    <div class="mb-4 jewelry_block col-lg-3 col-md-4 col-6" :class="{ 'col-lg-12 col-md-12 col-12 list_view mob-list-view-spacing' :viewType === 'list'}">
       <div class="product_box" v-if="data && data.main_sku">
           <div class="disc_chip_plp" v-if="!$country.is_india && data.discount_label">{{ data.discount_label }}% OFF</div>
           <div class="product-sku">{{data.main_sku}}</div>
           <router-link :to="localePath(data.full_slug)" class="on_hover">
               <div class="mob_mod">
                   <img class="front_img" width="246" height="246" :src="data.images.front" :alt="data.title">
                   <img v-if="data.images.left" loading="lazy" class="left_img" width="246" height="246" :src="data.images.left" :alt="data.title">
                   <img v-else loading="lazy" class="left_img" width="246" height="246" :src="data.images.front" :alt="data.title">
               </div>
           </router-link>
           <router-link :to="localePath(data.full_slug)" class="on_hover">
               <h3>{{ data.stone_one_shape }} {{data.title}}</h3>
               <p class="mb-1">Center Stone : {{ data.stone_one_weight }} Ct.</p>
               <p class="mb-3">{{ data.stone_one_color }} <span>|</span> {{ data.stone_one_clarity }} <span>|</span> {{ data.stone_one_lab }}</p>
           </router-link>
           <h4 class="mb-0">{{ $formatPrice(data.price) }}
           <span class="us_price" v-if="!$country.is_india && data?.discount_label">{{ $formatPrice( data.mrp ) }}</span>
           <span v-if="!$country.is_india && data?.lowest_price_label && data?.discount_label" class="lowest_price_plp mt-2">Lowest Price Ever</span>
            </h4>
           <div class="attr_box">
               <span v-if="data.returnSize && data.sub_type === 'in-stock-ring'">Ring Sizes: {{ data.returnSize }}</span>
               <span v-if="data.returnSize && data.sub_type === 'in-stock-earring'">Back Type: {{ data.returnSize }}</span>
               <span v-if="data.returnSize && data.sub_type === 'in-stock-pendant'">Chain Length: {{ data.returnSize }}</span>
           </div>
       </div>
    </div>
</template>

<script setup>
    const { data, viewType } = defineProps(['data', 'viewType'])
    const localePath = useLocalePath()
    const { $formatPrice, $country } = useNuxtApp()

    onMounted(() =>{
       
        if( typeof cls_InovaDiamonds_Iframe !== 'undefined' && cls_InovaDiamonds_Iframe.init_Session_Go !== undefined ){
            cls_InovaDiamonds_Iframe.init_Session_Go()
        }

            const script = document.createElement('script');
            script.src = 'https://vto.jewelry/?d=6LYC9UW';
            script.async = true;
            script.onload = () => {
            };
            document.head.appendChild(script);
       
    })
</script>

<style scoped>
h4 span.us_price {
    color: #656565;
    text-decoration: line-through;
    font-weight: 400;
    font-size: 14px;
}

.product-sku {
   display: none;
}
.attr_box {
   color: #909090;
   font-size: 14px;
   margin-top: 12px;
}

.left_img{
   display: none;
}
.front_img{
   display: block;
}
.loader_img{
   display: block;
}
.on_hover:hover .left_img{
   display:block
}
.on_hover:hover .front_img{
   display:none
}
.product_box {
    padding: 15px;
    border: 1px solid #eaeaea;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
}
.product_box:hover{
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.15);

}
a{
   display: inline-block;
   color: #353535;
}
h3 {
    font-size: 16px;
    font-weight: normal;
    line-height: 1.5;
    min-height: 50px;
    color: #353535;
}
h4 {
    font-size: 18px;
    font-weight: 600;
    color: #668b84;
}

p {
   color: #353535;
   font-size: 16px;
}
p span{
   color: #c4c4c4;
   padding: 0 3px;
}
@media(max-width: 992px){
   .product_box{
       padding: 10px;
   }
  
}
.v-zero{
   visibility: hidden;
   display: none;
}
@media(max-width: 767px){
  
   .row .jewelry_block:nth-child(2n+2) {
       /* padding: 0;
       padding-right: 10px;
       padding-left: 5px; */
       padding: 7px 12px 7px 7px;

   }
   .row .jewelry_block:nth-child(2n+1) {
       /* padding: 0;
       padding-left: 10px;
       padding-right: 5px; */
       padding: 7px 7px 7px 12px;
   }

   .row .jewelry_block.mob-list-view-spacing{
        padding: 7px 12px 7px 12px;

   }
   .jewelry_block {
       margin-bottom: 0px !important;
   }
   h4 {
       font-size: 18px;
       font-weight: 600;
       color: #668b84;
   }
   h3, p {
       font-size: 14px;
    
   }
   
   .list_view a{
        display: block;
    }
    .list_view h3{
        text-align: center;
        min-height: auto;
    }
    .list_view h4{
        text-align: center;
    }
    
    .list_view .mob_mod{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    }
    
    .list_view p{
        text-align: center;
    }

    .list_view .attr_box {
        text-align: center;
    }
}

</style>

